<template>
  <component :is="selectedComponent" />
</template>

<script>
import { computed } from 'vue';
import Dashboard from '@/views/Dashboard/Dashboard.vue';
import DashboardMedical from '@/views/Dashboard/DashboardMedical.vue';
import DashboardLegal from '@/views/Dashboard/DashboardLegal.vue';
import DashboardRealtor from '@/views/Dashboard/DashboardRealtor.vue';

export default {
  name: 'DashboardSelector',
  setup() {
    const industryId = (typeof window !== 'undefined') ? localStorage.getItem('industry_id') : null;

    const selectedComponent = computed(() => {
      // mapping: 1=medical, 2=legal, 3=dealer(default), 4=realtor
      switch (industryId) {
        case '1':
          return DashboardMedical;
        case '2':
          return DashboardLegal;
        case '4':
          return DashboardRealtor;
        default:
          return Dashboard; // dealer or undefined
      }
    });

    return { selectedComponent };
  }
};
</script>